<template>
  <div class="tw-pointer-events-none tw-fixed tw-inset-y-0 tw-right-0 tw-z-[201] tw-w-104 tw-overflow-hidden">
    <TransitionGroup
      tag="ol"
      class="tw-overflow-x-inherit tw-size-full tw-space-y-5 tw-overflow-y-auto tw-py-5 tw-pr-5"
      enter-active-class="tw-transition tw-duration-300 tw-ease-out"
      enter-from-class="tw-translate-x-10 tw-opacity-0"
      enter-to-class="tw-translate-x-0 tw-opacity-100"
      leave-active-class="tw-transition tw-duration-200 tw-ease-in"
      leave-from-class="tw-translate-x-0 tw-opacity-100"
      leave-to-class="tw-translate-x-10 tw-opacity-0"
      move-class="tw-transition-transform tw-duration-200 tw-ease-in-out"
    >
      <Notification
        v-for="notification in visibleNotifications"
        :key="notification.id"
        :notification
        @close="closeNotification"
      />
    </TransitionGroup>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import useNotiticationsStore from '@/stores/notifications';

import Notification from './Notification.vue';

const notificationsStore = useNotiticationsStore();
const { closeNotification } = notificationsStore;
const { visibleNotifications } = storeToRefs(notificationsStore);
</script>
